import React from 'react'
import MergeCompanyForm from './MergeCompanyForm'

function MergeCompanyModalContent({ request, onBack }) {
  const formId = 'merge_company_form'
  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content new-brp-modal">
          <div className="modal-header">
            <div className="dome-h2 dome-color-dark-grey">Merge Company</div>
          </div>
          <div className="modal-body">
            <MergeCompanyForm id={formId} request={request} />
          </div>
          <div className="modal-footer">
            <button
              className="dome-btn dome-btn-link dome-btn-link-cancel pull-left dome-color-med-grey"
              data-dismiss="modal"
              onClick={onBack}
            >
              cancel
            </button>
            <button className="dome-btn dome-btn-base dome-btn-aqua-stroke pull-right" type="submit" form={formId}>
              merge
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default MergeCompanyModalContent
